import { Field } from "enums";
import Validation from "services/validation.service";

const initialKdsFormState = (initialState = {}) => {
  const {
    name = "",
    outletId = "",
    type = "BAR",
    status = "ACTIVE",
    isDefault = false,
    // categories = [],
    products = [],
    // skus = [],
  } = initialState;

  return {
    name: {
      name: "name",
      label: "Name",
      value: name,
      type: Field.INPUT,
      validations: [Validation.required()],
      required: true,
      maxLength: 100,
    },
    outletId: {
      name: "outletId",
      label: "Outlet",
      value: outletId || null,
      type: Field.DROPDOWN,
      validations: [Validation.required()],
      required: true,
    },
    type: {
      name: "type",
      label: "Type",
      value: type,
      type: Field.DROPDOWN,
      options: [
        { text: "BAR", value: "BAR" },
        { text: "RESTAURANT", value: "RESTAURANT" },
        { text: "GARDEN", value: "GARDEN" },
        { text: "LAWN", value: "LAWN" },
      ],
      validations: [Validation.required()],
      required: true,
    },
    status: {
      name: "status",
      label: "Status",
      value: status,
      type: Field.DROPDOWN,
      options: [
        { text: "ACTIVE", value: "ACTIVE" },
        { text: "INACTIVE", value: "INACTIVE" },
      ],
      validations: [Validation.required()],
      required: true,
    },
    isDefault: {
      name: "isDefault",
      label: "Default",
      value: isDefault,
      type: Field.CHECKBOX,
    },
    // categories: {
    //   name: "categories",
    //   label: "Categories",
    //   value: categories,
    //   type: Field.ANY,
    // },
    products: {
      name: "products",
      label: "Products",
      value: products,
      type: Field.ANY,
    },
    // skus: {
    //   name: "skus",
    //   label: "Skus",
    //   value: skus,
    //   type: Field.ANY,
    // },
  };
};

export default initialKdsFormState;

